// Fisher-Yates shuffle
export function shuffleArray<T>(arr: T[]): T[] {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

export function getShuffleSettings() {
  return {
    shuffleQuestions: localStorage.getItem("shuffle_questions") === "true",
    shuffleAnswers: localStorage.getItem("shuffle_answers") === "true",
  };
}
